export default {
    data() {
        return {
            head: {
                link: this.prepareCanonicalLinkTag(),
            },
        };
    },
    methods: {
        prepareCanonicalLinkTag() {
            let url = this.$route.path !== '/' ? this.$config.FRONTEND_BASE_URL + this.$route.path : this.$config.FRONTEND_BASE_URL;
            const currentPage = this.$route.query && this.$route.query.currentPage ? this.$route.query.currentPage : null;
            if (currentPage !== null) {
                url += '?currentPage=' + currentPage;
            }

            return [
                {
                    hid: 'canonical',
                    type: 'link',
                    rel: 'canonical',
                    href: url,
                },
            ];
        },
    },
};
